import { defineComponent as u, openBlock as t, createElementBlock as a, mergeProps as i, unref as o, renderSlot as m, createElementVNode as e, createCommentVNode as g } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, L = { key: 1 }, k = { key: 2 }, M = { key: 3 }, h = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconCaretDoubleUp"
}, b = /* @__PURE__ */ u({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = Z(s);
    return (p, l) => (t(), a("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      m(p.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", f, l[0] || (l[0] = [
        e("path", { d: "M216.49,191.51a12,12,0,0,1-17,17L128,137,56.49,208.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0Zm-160-63L128,57l71.51,71.52a12,12,0,0,0,17-17l-80-80a12,12,0,0,0-17,0l-80,80a12,12,0,0,0,17,17Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", L, l[1] || (l[1] = [
        e("path", {
          d: "M208,200H48l80-80Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M133.66,114.34a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,208H208a8,8,0,0,0,5.66-13.66ZM67.31,192,128,131.31,188.69,192Zm-25-66.34a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,0l80,80a8,8,0,0,1-11.32,11.32L128,51.31,53.66,125.66A8,8,0,0,1,42.34,125.66Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", k, l[2] || (l[2] = [
        e("path", { d: "M213.66,194.34A8,8,0,0,1,208,208H48a8,8,0,0,1-5.66-13.66L108.69,128H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,208,128H147.31Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", M, l[3] || (l[3] = [
        e("path", { d: "M212.24,195.76a6,6,0,1,1-8.48,8.48L128,128.49,52.24,204.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0Zm-160-71.52L128,48.49l75.76,75.75a6,6,0,0,0,8.48-8.48l-80-80a6,6,0,0,0-8.48,0l-80,80a6,6,0,0,0,8.48,8.48Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", h, l[4] || (l[4] = [
        e("path", { d: "M213.66,194.34a8,8,0,0,1-11.32,11.32L128,131.31,53.66,205.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0Zm-160-68.68L128,51.31l74.34,74.35a8,8,0,0,0,11.32-11.32l-80-80a8,8,0,0,0-11.32,0l-80,80a8,8,0,0,0,11.32,11.32Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", w, l[5] || (l[5] = [
        e("path", { d: "M210.83,197.17a4,4,0,0,1-5.66,5.66L128,125.66,50.83,202.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0Zm-160-74.34L128,45.66l77.17,77.17a4,4,0,1,0,5.66-5.66l-80-80a4,4,0,0,0-5.66,0l-80,80a4,4,0,0,0,5.66,5.66Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  b as default
};
